<template>
  <el-dialog title="新增可用区" 
    :visible.sync="dialogVisible" 
    width="600px" 
    @close="resetForm"
    destroy-on-close
    :close-on-click-modal="false"
  >
    <el-form
      :visible.sync="dialogVisible"
      :model="createForm"
      :rules="rules"
      ref="createForm"
      label-width="140px"
      size="small"
    >
      <el-form-item label="可用区名称：" prop="name">
        <el-input v-model="createForm.name" placeholder="请输入可用区名称"></el-input>
      </el-form-item>

      <el-form-item label="提供商：" prop="region_id">
        <el-select 
          v-model="createForm.region_id" 
          placeholder="请选择提供商" 
          style="width: 100%;" 
          :loading="loading"
          @change="handleProviderChange"
        >
          <el-option 
            v-for="item in options" 
            :key="item.region_id" 
            :label="item.provider" 
            :value="item.region_id"
          ></el-option>
          <el-option v-if="!loading && options.length === 0" disabled value="">暂无可用提供商</el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="价格：" prop="price">
        <el-input v-model="createForm.price" placeholder="请输入价格"></el-input>
      </el-form-item>
      <el-form-item label="是否纳管：" prop="ext_01">
        <el-select v-model="createForm.ext_01" placeholder="请选择" style="width: 100%;">
          <el-option label="纳管" :value="0"></el-option>
          <el-option label="非纳管" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="规模：" prop="scale">
        <el-input type="textarea" :rows="3" v-model="createForm.scale" placeholder="请输入规模"></el-input>
      </el-form-item>
      <el-form-item label="GPU型号：" prop="gpu_model">
        <el-input v-model="createForm.gpu_model" placeholder="请输入GPU型号"></el-input>
      </el-form-item>
      <el-form-item label="状态：" prop="status">
        <el-select v-model="createForm.status" placeholder="请选择状态" style="width: 100%;">
          <el-option label="有效" :value="0"></el-option>
          <el-option label="关闭" :value="1"></el-option>
          <el-option label="待定" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="租赁规模：" prop="lease_scale">
        <el-select v-model="createForm.lease_scale" placeholder="请选择租赁规模" style="width: 100%;">
          <el-option label="任意" :value="0"></el-option>
          <el-option label="整租" :value="1"></el-option>
          <el-option label="散租" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="租赁形式：" prop="lease_type">
        <el-select v-model="createForm.lease_type" placeholder="请选择租赁形式" style="width: 100%;">
          <el-option label="任意" :value="0"></el-option>
          <el-option label="开口" :value="1"></el-option>
          <el-option label="闭口" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备规格：" prop="device_specification">
        <el-input v-model="createForm.device_specification" placeholder="请输入设备规格"></el-input>
      </el-form-item>
      <el-form-item label="存储：" prop="storage">
        <el-input v-model="createForm.storage" placeholder="请输入存储"></el-input>
      </el-form-item>
      <el-form-item label="存储网络：" prop="storage_network">
        <el-input v-model="createForm.storage_network" placeholder="请输入存储网络"></el-input>
      </el-form-item>
      <el-form-item label="计算网络：" prop="compute_network">
        <el-input v-model="createForm.compute_network" placeholder="请输入计算网络"></el-input>
      </el-form-item>
      <el-form-item label="出口规格：" prop="internet_spec">
        <el-input v-model="createForm.internet_spec" placeholder="请输入出口规格"></el-input>
      </el-form-item>
      <el-form-item label="可用期开始时间：" prop="start_time">
        <el-date-picker v-model="createForm.start_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="可用期结束时间：" prop="end_time">
        <el-date-picker v-model="createForm.end_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间" style="width: 100%;"></el-date-picker>
      </el-form-item>
      

      <el-form-item label="说明：" prop="remark">
        <el-input type="textarea" :rows="3" v-model="createForm.remark" placeholder="请输入说明"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="submitForm('createForm')">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreateProvider',
  data() {
    return {
      dialogVisible: false,
      loading: true,
      options: [], // 存储 region_id -> provider 映射
      createForm: {
        name: '',
        region_id: '', // ✅ 仅保留 region_id
        // ❌ 移除 provider 字段，避免冗余
        gpu_model: '',
        device_specification: '',
        storage: '',
        storage_network: '',
        compute_network: '',
        internet_spec: '',
        price: '',
        scale: '',
        lease_scale: 0,
        lease_type: 0,
        status: 0,
        ext_01: 0,
        start_time: '',
        end_time: '',
        remark: ''
      },
      rules: {
        name: [{ required: true, message: '请输入可用区名称', trigger: 'blur' }],
        region_id: [{ required: true, message: '请选择提供商', trigger: 'change' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        ext_01: [{ required: true, message: '请选择是否纳管', trigger: 'change' }],
        start_time: [
          {
            validator: (rule, value, callback) => {
              // 非必填，留空也通过
              callback();
            },
            trigger: 'change'
          }
        ],

        // 结束时间：非必填，但若填写则必须 > 开始时间
        end_time: [
          {
            validator: (rule, value, callback) => {
              const startTime = this.createForm.start_time;
              const endTime = value;

              // 如果两个时间都没填 → 通过
              if (!startTime && !endTime) {
                return callback();
              }

              // 如果只填了结束时间 → 通过（非必填）
              if (!startTime && endTime) {
                return callback();
              }

              // 如果只填了开始时间 → 通过
              if (startTime && !endTime) {
                return callback();
              }

              // 两个都填了，才做比较
              const start = new Date(startTime);
              const end = new Date(endTime);

              if (end <= start) {
                callback(new Error('可用期结束时间必须大于开始时间'));
              } else {
                callback(); // 校验通过
              }
            },
            trigger: 'change'
          }
        ],
      }
    };
  },
  methods: {
    openDialog() {
      this.fetchProviders();
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.createForm.clearValidate();
      });
    },
    resetForm() {
      if (this.$refs.createForm) {
        this.$refs.createForm.resetFields();
      }
    },
    handleProviderChange(regionId) {
      const selected = this.options.find(item => item.region_id === regionId);
      if (selected) {
        // 如果后端需要 provider 字段，可以在这里临时加，或提交时再补
        // this.createForm.provider = selected.provider; // 只有当后端需要才加
      }
    },
    fetchProviders() {
      this.loading = true;
      return this.$axios.get('/api-30216/api/regions')
        .then(res => {
          if (res.code === 200 && Array.isArray(res.data)) {
            // ✅ 正确映射 id -> region_id, provider
            this.options = res.data.map(item => ({
              region_id: item.id,
              provider: item.provider || '未知提供商'
            }));
          } else {
            this.$message.error(res.message || '加载提供商失败');
            this.options = [];
          }
        })
        .catch(err => {
          this.$message.error('请求失败，请检查网络');
          console.error(err);
          this.options = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;

        // ✅ 提交前：如果后端需要 provider 字段，动态补全
        const selected = this.options.find(item => item.region_id === this.createForm.region_id);
        const postData = {
          ...this.createForm,
          provider: selected ? selected.provider : '' // 补全 provider
        };

        this.$axios.post('/api-30216/api/zones', postData)
            .then(res => {
            const responseData = res.data || res;
            if (responseData.code === 200) {
              this.$message.success(responseData.message || '新增成功');
              this.dialogVisible = false;
              this.$emit('success');
            } else {
              this.$message.error(responseData.message || '新增失败');
            }
          })
          .catch(err => {
            let errorMessage = '请求失败';
            if (err.response && err.response.data) {
              errorMessage = err.response.data.message || errorMessage;
            } else if (err.message) {
              errorMessage = err.message;
            }
            this.$message.error(errorMessage);
            console.error('请求错误详情:', err);
          });
      });
    }
  }
};
</script>

<style scoped>
.el-dialog .el-form-item {
  margin-bottom: 18px;
}
</style>